import { render, staticRenderFns } from "./InstitutionEditTabPhysicians.vue?vue&type=template&id=8f4b6214&"
import script from "./InstitutionEditTabPhysicians.vue?vue&type=script&lang=js&"
export * from "./InstitutionEditTabPhysicians.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionEditTabPhysicians.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports